import { PropsWithChildren, useState } from "react";
import { useNetwork } from "../../hooks/useNetwork/useNetwork";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { StatusMessage } from "../status-message/statusMessage";
import { convertFormDataToInput } from "../../util/convert-form-data-to-input-data/convertFormDataToInputData";
import { getErrorText } from "../../util/error/getErrorText";
import { useApp } from "../../hooks/use-app/useApp";

interface Props extends PropsWithChildren {
  action: string;
  method: string;
  actionLabel: string;
  errorMap?: Record<string, string>;
  error?: string;
  successMessage?: React.ReactNode;
  onSuccess?: (response: any) => any;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => any;
}

export const Form: React.FC<Props> = ({
  action,
  method,
  actionLabel,
  errorMap,
  error,
  successMessage,
  onSuccess,
  onSubmit,
  children,
}) => {
  const app = useApp();
  const { loading, network } = useNetwork();
  const { localize } = useLocalization();
  const [_error, setError] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);

  return (
    <form
      action={`/${app.name}/api${action}`}
      method={method}
      encType="application/x-www-form-urlencoded"
      onSubmit={
        onSubmit
          ? onSubmit
          : async (e) => {
              e.preventDefault();

              setSuccess(false);

              if (loading) {
                return;
              }

              try {
                const response = await network(action, {
                  method,
                  json: convertFormDataToInput(new FormData(e.currentTarget)),
                });

                //@ts-ignore I don't know why this is not typed correctly
                e.target.reset();
                setSuccess(true);

                if (typeof onSuccess === "function") {
                  onSuccess(response);
                }
              } catch (error) {
                if (errorMap) {
                  setError(getErrorText(error, errorMap));
                } else {
                  console.error(error);
                }
              }
            }
      }
    >
      {children}
      {(error || _error) && (
        <StatusMessage type="error">{error || _error}</StatusMessage>
      )}
      {success && successMessage && (
        <StatusMessage type="success">{successMessage}</StatusMessage>
      )}
      <button type="submit" disabled={loading}>
        {loading ? localize("loading") : actionLabel}
      </button>
    </form>
  );
};
